import { Entity } from '@core/entities/entity'

import { ITaskPayload } from '@core/entities/InspectionItemAnswer/ITaskPayload'
import { plainToInstance, Type } from 'class-transformer'
import { TaskTemplatePriorityType } from '@core/entities/task/TaskTemplateProperties'
import { TaskAssignableUser } from '@core/entities/task/TaskAssignableUser'
import { TaskAttachmentsWrapper } from '../task/TaskAttachment'

export class TaskPayload extends Entity<ITaskPayload> {
  projectId: number

  taskTemplateId: number

  taskTemplateVersionId: number

  summary: string

  assigneeUserId: number

  priority: TaskTemplatePriorityType

  dueDate: string

  @Type(() => TaskAttachmentsWrapper)
  attachments: TaskAttachmentsWrapper

  // We cannot use TaskStep here, as it causes a circular reference error in typescript
  stepAnswers: any

  draftId?: number

  @Type(() => TaskAssignableUser)
  assigneeUser?: TaskAssignableUser

  taskTemplateName?: string

  // We cannot use TaskTemplate here, as it causes a circular reference error in typescript
  taskTemplate?: {
    id: number
    name: string
  }

  // We cannot use TaskTemplateVersion here, as it causes a circular reference error in typescript
  taskTemplateVersionResult?: {
    id: number
  }

  public static new(payload: unknown): TaskPayload {
    const entity = plainToInstance(TaskPayload, payload)

    return entity
  }
}
